import { BASE_API_URL } from "utils/constants";
import { get, post } from '../../utils/api';
import { DataResponse } from 'services/response';
import { ProductModel } from 'services/Main/common_services';


export type RemindModel = {
  stt: number,
  companyName: string,
  remindConfigName: string,
  phanLoaiVatTuName: string,
  nhomVatTuName: string,
  sapCode: string,
  productName: string,
  frequency: string,
  createTime: string,
  createBy: string,
  actived: boolean
  remindConfigCode: string;
  remindConfigId: string
}
export type DetailModel = {
  remindConfigId: string,
  companyCode: string,
  remindConfigType: string,
  isRepeat: boolean,
  monthAvailable: number,
  frequency: boolean,
  actived: boolean,
  phanLoaiVatTuList: string[],
  nhomVatTuList: string[],
  productList: ProductModel[],
}

// cập nhật lịch nhắc nhở
export type RemindUpdateModel = {
  stt: string,
  registerCode: string,
  profileName: string,
  sapCode: string,
  productName: string,
  warrantyDate: string,
  startDate: string,
  warrantyName: string,
  productWarrantyId: string
  actived: boolean
}


// Model của nhắc nhở thời gian lịch bảo hành
export type WarrantyTimeRemindModel = {
  stt: number,
  remindDate: string,
  registerCode: string,
  remindConfigCode: string,
  profileCode: string,
  status: boolean,
  message: string
}

// ============ Khai báo phương thức =====================
export interface IRemindServices {
  // danh sách nhắc nhở
  getDataListWarrantyRemind(data: object): Promise<DataResponse<RemindModel[]>>

  // create
  createWarrantyRemind(data: object): Promise<DataResponse<null>>
  // edit
  editWarrantyRemind(data: object): Promise<DataResponse<null>>
  // detail
  detailWarrantyRemind(remindConfigId: string): Promise<DataResponse<DetailModel>>

  // cập nhật lịch nhắc cho phiếu ĐKBH đã tạo
  reminderUpdateCalendar(data: object): Promise<DataResponse<RemindUpdateModel[]>>
  // xử lý cập nhật lịch nhắc nhở
  caculateCalendar(data: object): Promise<DataResponse<any>>

  // Nhắc nhở lịch bảo hành
  warrantyTimeRemind(data: object): Promise<DataResponse<WarrantyTimeRemindModel[]>>
}
// Hàm khởi tạo các phương thức service
export function createWarrantyRemindServices(): IRemindServices {
  return {
    //  data từng tiêu chí
    getDataListWarrantyRemind: async (data) => {
      return (await post(BASE_API_URL, `RemindWarranty/list`, data)).data;
    },

    // create
    createWarrantyRemind: async (data) => {
      return (await post(BASE_API_URL, `RemindWarranty/create`, data)).data;
    },
    // edit
    editWarrantyRemind: async (data) => {
      return (await post(BASE_API_URL, `RemindWarranty/edit`, data)).data;
    },
    // detail
    detailWarrantyRemind: async (remindConfigId: string) => {
      return (await get(BASE_API_URL, `RemindWarranty/get/` + remindConfigId)).data;
    },
    // cập nhật lịch nhắc cho phiếu ĐKBH đã tạo
    reminderUpdateCalendar: async (data) => {
      return (await post(BASE_API_URL, `RemindWarranty/get-list-product-warranty`, data)).data;
    },
    // xử lý cập nhật lịch nhắc nhở
    caculateCalendar: async (data) => {
      return (await post(BASE_API_URL, `RemindWarranty/cal-calendar-list-product-warranty`, data)).data;
    },
    warrantyTimeRemind: async (data) => {
      return (await post(BASE_API_URL, `RemindWarrantyCalendar/list`, data)).data;
    },
  };
}
